import Hashes from 'jshashes';
export default (function (str) {
  return new Hashes.SHA256().b64(str);
});